import { Link } from 'react-router-dom'
import './HomeTrademarks.css'
import homeTradeMarksImage1 from '../../../assets/images/homeTradeMarksImage1.webp'
import homeTradeMarksImage2 from '../../../assets/images/homeTradeMarksImage2.webp'

const HomeTrademarks = () => {
  return (
    <section className='home__trademarks-section'>
        <h2 className="home__trademarks-title mont-m">Наши торговые марки</h2>
        <div className="home__trademarks-cards">
            <div className="home__trademarks-card">
                <div className="home__trademarks-card-texts">
                    <h3 className="home__trademarks-card-title mont-m">Pastoral</h3>
                    <p className="home__trademarks-card-text int-r-21">Bonjour от ТМ «Pastoral»! <br />Сердечно приветствуем вас на нашей странице – аутентичных и премиальных молочных продуктов. Мы хотим предложить вам подлинное à la carte. ТМ «Pastoral» – это лучшие молочные продукты, изготовленные по французским традициям. Технологи нашего завода ориентируются на французские рецептуры...</p>
                    <Link to={"/ru/about-us/pastoral/"} className='home__trademarks-card-link int-r-21'>Детальнее</Link>
                </div>
                <img src={homeTradeMarksImage1} alt="Pastoral" className="home__trademarks-card-image" />
                    <Link to={"/ru/about-us/pastoral/"} className='home__trademarks-card-link-mobile int-r-21'>Детальнее</Link>
            </div>
            <div className="home__trademarks-card reverce">
                <div className="home__trademarks-card-texts">
                    <h3 className="home__trademarks-card-title mont-m">Мумуля</h3>
                    <p className="home__trademarks-card-text int-r-21">Молочная марка "Мумуля". Му-Му-Му!! <br />Молоко – это первый продукт, который нужен всем для жизни, роста и здоровья, и ТМ Мумуля хорошо это знает. Наша Мумуля — с дипломом пищевого института, с идеями повара-кулинара, заботливым сердцем мамы и амбициями блоггерши-миллионницы.
Она знает, когда молоко должно быть теплым, а когда охлажденным, как...
 </p>
                    <Link to={"/ru/about-us/mumulya/"} className='home__trademarks-card-link int-r-21'>Детальнее</Link>
                </div>
                <img src={homeTradeMarksImage1} alt="Мумуля" className="home__trademarks-card-image" />
                    <Link to={"/ru/about-us/mumulya/"} className='home__trademarks-card-link-mobile int-r-21'>Детальнее</Link>
            </div>
            <div className="home__trademarks-card">
                <div className="home__trademarks-card-texts">
                    <h3 className="home__trademarks-card-title mont-m">Молокомаркет</h3>
                    <p className="home__trademarks-card-text int-r-21">Молокомаркет – это фирменная сеть магазинов Домановского маслосырзавода, где мы собрали полный ассортимент ТМ «Pastoral» и «Мумуля». Покупка в Молокомаркет – это гарантия свежих молочных продуктов по ценам производителя. Только у нас приобрести эксклюзивные новинки от ТМ Pastoral, которые не попадают в крупные торговые сети</p>
                    {/* <Link to={""} className='home__trademarks-card-link int-r-21'>Перейти к магазину</Link> */}
                </div>
                <img src={homeTradeMarksImage2} alt="Молокомаркет" className="home__trademarks-card-image" />
                    {/* <Link to={""} className='home__trademarks-card-link-mobile int-r-21'>Перейти к магазину</Link> */}
            </div>
        </div>
    </section>
  )
}

export default HomeTrademarks